import { Entity } from '../entity'
import { PrepaymentSetting } from '../settings/general.settings';
import { AdjustmentType } from '../shared/code';
import { Lex } from '../shared/lexorank';
import { Policy, PolicyNotification, PolicyOptionVisibility } from './policy';

export enum QuotePolicyReminderType {
    Acceptance = 'Acceptance',
    Payment = 'Payment',
}

export enum QuotePolicyDates {
    SendDate = 'SendDate',
    ExpiryDate = 'ExpiryDate',
    AcceptedDate = 'AcceptedDate',
}

export enum QuotePolicyPrepaymentRuleOperator {
    LessThan = 'LessThan',
    LessThanOrEqual = 'LessThanOrEqual',
    // Equal = 'Equal',
    GreaterThanOrEqual = 'GreaterThanOrEqual',
    GreaterThan = 'GreaterThan',
}

export enum QuotePolicyPrepaymentRuleType {
    Percentage = 'Percentage',
    Amount = 'Amount',
}

export enum QuotePolicyPrepaymentSkipType {
    NotApplicable = 'Not Applicable',
    Include = 'Include',
    Exclude = 'Exclude',
}

export enum QuotePolicyJobConvertSplitType {
    //   None = 'None',
    JobTemplate = 'Job Template',
    ItemCategory = 'Item Category',
    QuoteSection = 'Quote Section'
}

export enum QuotePolicyNotificationType {
    QuoteAccepted = 'Quote Accepted',
    QuoteDeclined = 'Quote Declined',
    QuotePrepaid = 'Quote Prepaid',
}

export interface QuotePolicyAcceptance {
    _id: string;
    poNumber: PolicyOptionVisibility;
    attachments: PolicyOptionVisibility;
    signature: PolicyOptionVisibility;
    allowOnlineAcceptance: boolean;
    // allowOnlinePayment: boolean;
}

export interface QuotePolicyJobConversion {
    _id: string;
    autoConvert: boolean;
    copyActivities: boolean;
    split: QuotePolicyJobConvertSplitType;
    jobTemplate: Entity;
}

export interface QuotePolicyReminder {
    _id: string;
    active: boolean;
    type: QuotePolicyReminderType,
    date: QuotePolicyDates,
    offset: number;
    message: string;
    subject: string;
}

export interface QuotePolicyReminders {
    _id: string;
    enableForAcceptance: boolean;
    acceptance: QuotePolicyReminder[];

    enableForPayment: boolean;
    payment: QuotePolicyReminder[];
}

export type QuotePolicyNotification = PolicyNotification<QuotePolicyNotificationType>;

export interface QuotePolicyNotifications {
    _id: string;
    enabled: boolean;
    accept: QuotePolicyNotification;
    decline: QuotePolicyNotification;
    prepaid: QuotePolicyNotification;
}

export interface QuotePolicyPrepaymentRule {
    _id: string;
    quoteValue: number;
    operator: QuotePolicyPrepaymentRuleOperator;
    prepaymentType: QuotePolicyPrepaymentRuleType;
    amount: number;
    sortOrder: Lex | any;
    active: boolean;
}

export interface QuotePolicyPrepayments {
    _id: string;
    enabled: boolean;
    allowOverride: boolean;
    rules: QuotePolicyPrepaymentRule[];
    settings: PrepaymentSetting
}

export interface QuotePolicyDefaults {
    _id: string;
    adjustmentType: AdjustmentType;
    expiryDays: number;
}

export interface QuotePolicy extends Policy {
    acceptance: QuotePolicyAcceptance;
    jobConversion: QuotePolicyJobConversion;
    prepayments: QuotePolicyPrepayments;
    reminders: QuotePolicyReminders;
    notifications: QuotePolicyNotifications;
    defaults: QuotePolicyDefaults;
}
